import React from 'react';

import { createUUID } from './util';

export const useUUID = () => {
  const uuid = React.useRef<string>(createUUID());
  return uuid.current;
};
